<div class="grid grid-cols-1 md:grid-cols-2">
    <div
        class="flex flex-col justify-center text-center md:order-2 md:text-left">
        <h2 class="pb-4 text-3xl font-semibold md:text-4xl">
            Why <span class="text-red"> Follow Alice? </span>
        </h2>
        <p class="px-4 md:w-1/2 md:px-0">
            {{ whyDesc?.body }}
        </p>
        <app-cta-button
            [additionalClasses]="['py-2 px-8 mt-4 hidden md:block md:mx-0']"
            [link]="['/about-us']">
            About Us
        </app-cta-button>
    </div>
    <div class="relative md:order-1">
        <div
            class="airplane-map-background lazyload flex w-auto items-center justify-center bg-cover bg-center bg-no-repeat md:bg-auto">
            <app-customer-reviews-container></app-customer-reviews-container>
        </div>
    </div>
</div>

<div
    class="grid grid-cols-1 gap-8 overflow-x-hidden md:mx-auto md:max-w-screen-xl md:grid-cols-3 md:gap-0 md:overflow-x-visible">
    @for (
        reason of reasons | async;
        track reason.sys.id;
        let even = $even;
        let last = $last;
        let index = $index;
        let first = $first
    ) {
        <div>
            <app-home-why-followalice-reason-block
                [reason]="reason"
                [left]="even"
                [last]="last"
                [first]="first"
                [index]="index"
                class="block">
            </app-home-why-followalice-reason-block>
        </div>
    }
</div>
